import Control from './control';
import merge from 'lodash-es/merge';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';
import get from 'lodash-es/get';
import pick from 'lodash-es/pick';
import each from 'lodash-es/each';
import omit from 'lodash-es/omit';
import { getDefaultControlStyle, getDefaultControl } from './checkbox.defaults';
import getDisabledStyle from '../css/disabledStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';

export default class Checkbox extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this.addApi(this, 'text', () =>
      this._checkDataOption('text', get(this._controlOptions,'label.text','')),
      {formatter:'label.textFormatter'}
    );
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    const instance = this.instance;
    const path = this.path;
    const gridElement = options.gridElement;
    if(gridElement){
      this.grid = this.parentControl;
      control.gridSelectionSync =        
        this.grid.options.selectionMode &&
        this.grid.options.selectionMode !== 'none' &&
        this.grid.options.columns[gridElement.cellIndex].gridSelectionSync;
    }

    if (!control.el) {
      // console.log('control has no el yet', control.el);
      control.el = getDefaultControl();
      if (!control.isLayoutMode) {
        control.el.addEventListener('mouseover', function() {
          control.isHover = true;
          control.render();
        });
        control.el.addEventListener('mouseout', function() {
          control.isHover = false;
          control.render();
        });

        control.el.addEventListener('focus', function() {
          control.isFocused = true;
          control.render();
          // console.log('checkbox focus');
        });

        control.el.addEventListener('blur', function() {
          control.isFocused = false;
          control.render();
          // console.log('checkbox blur');
        });

        control.el.addEventListener('click', function(ev) {
          // console.log({ gridElement: gridElement });
          if (control.gridSelectionSync) {
            return;
          }

          control.isChecked = !control.isChecked;
          control.render();
          //updateDataSourceParameter(control, options, instance);

          if (options.trigger) {
            if (!isFunction(options.trigger)) {
              console.error("checkbox's click trigger should be a function", options.trigger);
            } else {
              options.trigger.apply(this, [options, instance, control, path, ev]);
            }
          }

          if (options.event) {
            if (!isString(options.event)) {
              console.error("checkbox's click event should be a string", options.event);
            } else {
              instance.fire(
                options.event,
                pick(options, [
                  'name',
                  'isChecked',
                  'value.defaultValue',
                  'type',
                  'label',
                  'toggleGroup',
                  'gridElement',
                ]),
                control,
                path,
                ev
              );
            }
          }

          control.doResetReload();
        });
      }
    }

    // console.log('render checkbox', options);
    var stylePatch = {};
    var bodyStylePatch = {};
    var iconStylePatch = {};
    var iconPathPatch = {};
    var labelStylePatch = {};
    var defaultStyle = getDefaultControlStyle(control);
    var iconEl = control.el.getElementsByClassName('icon')[0];
    var pathEl = iconEl.getElementsByTagName('path')[0];
    var labelEl;
    var bodyEl = control.el.getElementsByClassName('body')[0];
    var frameProps = [
      'top',
      'left',
      'right',
      'bottom',
      'margin',
      'position',
      'display',
      'width',
      'height',
    ];
    if (!options.label) {
      options.label = {};
    }

    if (!options.label.align) {
      options.label.align = 'right';
    }

    if (options.label.visible === undefined && control.text) {
      options.label.visible = true;
    }

    var labelIndex = options.label.align == 'left' || options.label.align == 'top' ? 0 : 1;
    var labels = control.el.getElementsByClassName('label');
    each(labels, function(label, i) {
      if (i == labelIndex) {
        labelEl = label;
      } else {
        label.style.display = 'none';
      }
    });
    // if (control.isLayoutMode) {
    //   labelEl.style.pointerEvents = 'none';
    // }
    //[2].innerHTML = options.label&&options.label.text||'';
    merge(stylePatch, defaultStyle.normal);
    merge(bodyStylePatch, defaultStyle.body.normal);
    merge(iconStylePatch, defaultStyle.icon.normal);
    merge(iconPathPatch, defaultStyle.iconPath.normal);
    merge(labelStylePatch, defaultStyle.label.normal);

    if (options.label.visible) {
      merge(bodyStylePatch, defaultStyle.body[options.label.align]);
      merge(labelStylePatch, defaultStyle.label[options.label.align]);
      merge(iconStylePatch, defaultStyle.icon[options.label.align]);
    }

    if (options.style && options.style.normal) {
      merge(stylePatch, pick(options.style.normal, frameProps));
      merge(iconStylePatch, omit(options.style.normal, frameProps));
    }

    merge(stylePatch, control.frameStyle);

    if (options.label.visible && options.label.style && options.label.style.normal) {
      merge(labelStylePatch, options.label.style.normal);
    }

    if (control.isFocused) {
      merge(stylePatch, defaultStyle.focused);
      merge(bodyStylePatch, defaultStyle.body.focused);
      merge(iconStylePatch, defaultStyle.icon.focused);
      if (options.style && options.style.focused) {
        merge(stylePatch, pick(options.style.focused, frameProps));
        merge(iconStylePatch, omit(options.style.focused, frameProps));
      }

      if (options.label.visible) {
        merge(labelStylePatch, defaultStyle.label.focused);
        if (options.label.style && options.label.style.focused) {
          merge(labelStylePatch, options.label.style.focused);
        }
      }
    }

    if (control.isHover) {
      merge(stylePatch, defaultStyle.hover);
      merge(bodyStylePatch, defaultStyle.body.hover);
      merge(iconStylePatch, defaultStyle.icon.hover);
      if (options.style && options.style.hover) {
        merge(stylePatch, pick(options.style.hover, frameProps));
        merge(iconStylePatch, omit(options.style.hover, frameProps));
      }

      if (options.label.visible) {
        merge(labelStylePatch, defaultStyle.label.hover);
        if (options.label.style && options.label.style.hover) {
          merge(labelStylePatch, options.label.style.hover);
        }
      }
    }

    if (control.gridSelectionSync) {
      // console.log('gridSelectionSync', gridElement.rowId, this.grid.value);
      if (this.grid.options.idForceUnique) {
        control.isChecked = (this.grid.value || []).indexOf(gridElement.rowId) !== -1;
      } else {
        control.isChecked = (this.grid.value || []).indexOf(gridElement.rowIndex) !== -1;
      }
    } else if (control.isChecked === undefined) {
      control.isChecked = options.isChecked || false;
    }

    if (control.isChecked) {
      merge(iconPathPatch, defaultStyle.iconPath.checked);
    }

    if (control.disabled) {
      merge(stylePatch, getDisabledStyle());
      if (options.style && options.style.disabled) {
        merge(stylePatch, options.style.disabled);
      }

      if (control.isLayoutMode) {
        delete stylePatch.pointerEvents;
      }
    }

    let scheme = lookAndFeel(options.lookAndFeel, stylePatch.height);
    // console.log('scheme', options.lookAndFeel, scheme);
    updateStyleByRef(
      [stylePatch, bodyStylePatch, iconStylePatch, iconPathPatch, labelStylePatch],
      scheme
    );

    // console.log('iconStylePatch', iconStylePatch);
    updateStyle(control.el, stylePatch, control.currentStyle);
    control.currentStyle = stylePatch;

    updateStyle(bodyEl, bodyStylePatch, control.currentBodyStyle);
    control.currentBodyStyle = bodyStylePatch;

    updateStyle(iconEl, iconStylePatch, control.currentIconStyle);
    control.currentIconStyle = iconStylePatch;

    updateStyle(pathEl, iconPathPatch, control.currentIconPathStyle);
    control.currentIconPathStyle = iconPathPatch;

    updateStyle(labelEl, labelStylePatch, control.currentLabelStyle);
    control.currentLabelStyle = labelStylePatch;
    if (options.label.visible) {
      labelEl.innerHTML = control.text;
    }

    return control.el;
  }
}
